import { Tabs } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TabLastConsumer from './components/TabLastConsumer';
import TabProject from './components/TabProject';


// TỔNG HỢP KÍCH HOẠT BẢO HÀNH
const createWarrantyActiveReport = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();

    const [activeKey, setActiveKey] = useState('1')
    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.report-warranty-active'),
          },
        ]}
      >
        <BoxContainer >
          <Tabs
            onChange={(activeKey: string) => {
              setActiveKey(activeKey)
            }}
            className='[&_.ant-tabs-tab]:!font-semibold'
            items={[
              {
                key: "1",
                label: t("warranty-active.last-consumer"),
                children: <TabLastConsumer activeKey={activeKey} />
              },
              // {
              //   key: "2",
              //   label: t("warranty-active.agency-to-consumer"),
              //   children: <TabAgencyToConsumer activeKey={activeKey} />
              // },
              {
                key: "3",
                label: t("dashboard.function-group.project"),
                children: <TabProject activeKey={activeKey} />
              },
            ]} />
        </BoxContainer>
      </PageWrapper>
    )
  })
}

export default createWarrantyActiveReport